__turbopack_context__.v({
  "item": "StickyNav-module__Oo5NkW__item",
  "label": "StickyNav-module__Oo5NkW__label",
  "link": "StickyNav-module__Oo5NkW__link",
  "linkActive": "StickyNav-module__Oo5NkW__linkActive",
  "list": "StickyNav-module__Oo5NkW__list",
  "nav": "StickyNav-module__Oo5NkW__nav",
  "pill": "StickyNav-module__Oo5NkW__pill",
  "pillSlot": "StickyNav-module__Oo5NkW__pillSlot",
});
